module.exports = __webpack_public_path__ + "img/logo.ae40dc3c.png";